import { getEnvironmentConfig } from 'app-components/utils/core';
import { call, put, takeEvery } from 'redux-saga/effects';

import AxiosFactory from 'utils/axiosFactory';
import * as uiConversationsActions from './aiConversationsActions';

const constructUrl = () => `${getEnvironmentConfig().services_url}/llm/chat-poc`;

export function* makeAiPromptRequest(action) {
  try {
    const qcsAxios = AxiosFactory.get('qcs');
    const requestUrl = constructUrl();
    const returnData = yield call(qcsAxios.post, requestUrl, action.payload);
    yield put(uiConversationsActions.makeAiPromptRequestSuccess(returnData.data));
    action.meta?.resolve?.(returnData);
  } catch (error) {
    assert(false, error);
    yield put(uiConversationsActions.makeAiPromptRequestFailure);
    action.meta?.reject?.(error);
  }
}

export function* makeAiPromptRequestActionWatcher() {
  yield takeEvery(uiConversationsActions.makeAiPromptRequestAction, makeAiPromptRequest);
}

export default [makeAiPromptRequestActionWatcher];
